module.exports = __webpack_public_path__ + "static/media/bo.2c019392.png";